import { useIntl } from "react-intl";

import testIds from "constants/testIds";
import Select from "components/v2/Select/Select";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { useEditShipmentLock } from "@RequestFormV2/context/editShipmentLock";
import { useOrganisation } from "@RequestFormV2/sections/Organisation/context";

export default function LocationDetailsSection() {
  const intl = useIntl();
  const isEditShipmentLock = useEditShipmentLock();
  const { startingPoint, locationOptions, selectedLocation, invoiceLocationDetails } = useOrganisation();

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.organisation.location-details",
          defaultMessage: "Location details",
        })}
        required
      />

      <div className="rfv2-form-section__content">
        <div className="rfv2-two-column-grid">
          <Select
            name="organizational.location"
            label={startingPoint?.label}
            options={locationOptions}
            required
            preselect={!isEditShipmentLock}
            isClearable={!isEditShipmentLock}
            isDisabled={isEditShipmentLock}
            testId={testIds.REQUEST_FORM_ORGANISATION_PAYMENT_LOCATION}
          />

          {selectedLocation && invoiceLocationDetails && (
            <Select
              name="organizational.invoice_location"
              label={invoiceLocationDetails.label}
              options={invoiceLocationDetails.dropdown_values}
              required={invoiceLocationDetails.mandatory}
              placeholder={invoiceLocationDetails.placeholder}
              isClearable
              preselect
              testId={testIds.REQUEST_FORM_ORGANISATION_INVOICE_LOCATION}
            />
          )}
        </div>
      </div>
    </div>
  );
}
